"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Clickable = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var lodash_1 = require("lodash");

var DynamicTag_1 = require("./DynamicTag");

var ClickableStyled = styled_components_1.default(DynamicTag_1.DynamicTag)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: inherit;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  position: relative;\n  background-color: transparent;\n  outline: none;\n  border: none;\n  border-radius: 0;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  vertical-align: middle;\n  text-decoration: none;\n\n  &:disabled {\n    pointer-events: none;\n    cursor: default;\n  }\n"], ["\n  font-family: inherit;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  position: relative;\n  background-color: transparent;\n  outline: none;\n  border: none;\n  border-radius: 0;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  vertical-align: middle;\n  text-decoration: none;\n\n  &:disabled {\n    pointer-events: none;\n    cursor: default;\n  }\n"])));

function Clickable(_a) {
  var _b;

  var _c = _a.component,
      component = _c === void 0 ? 'button' : _c,
      _d = _a.type,
      type = _d === void 0 ? 'button' : _d,
      _e = _a.disabled,
      disabled = _e === void 0 ? false : _e,
      tagRef = _a.tagRef,
      rest = __rest(_a, ["component", "type", "disabled", "tagRef"]);

  var ComponentProp = component;

  if (ComponentProp === 'button' && rest.href) {
    ComponentProp = 'a';
  }

  if (!disabled && type === 'button' && ComponentProp === 'button' && !lodash_1.isFunction(rest.onClick)) {
    throw new Error('Button component must be passed an onClick method, or be disabled, type="submit", or a non-button element or component.');
  }

  var props = __assign((_b = {
    type: type,
    disabled: disabled,
    role: null
  }, _b['aria-disabled'] = disabled, _b.component = ComponentProp, _b), rest);

  if (ComponentProp === 'button') {
    props.type = type;
    props.disabled = disabled;
    props.role = 'button';
  } else {
    if (ComponentProp !== 'a' || !rest.href) {
      props['aria-disabled'] = disabled;
    }
  }

  return React.createElement(ClickableStyled, __assign({
    tagRef: tagRef
  }, props));
}

exports.Clickable = Clickable;
var templateObject_1;